// Packages
import { useEffect } from "react"
import { Route, Routes, useLocation } from "react-router-dom"

// Utils
import { setScroll } from "components/Stacker/utils/Scrolling"

// tracking

// HoF
import PageWrapper from "components/PageWrapper"

// Components
import AmuletStackerPage from "components/pages/AmuletStackerPage/AmuletStackerPage"
import BraceletStackerPage from "components/pages/BraceletStackerPage/BraceletStackerPage"

// Actions
import {
  enableSPA,
  getCSRFToken,
} from "components/Stacker/actions/ApplicationActions"
import { useDispatch } from "react-redux"
import { useLayoutEffect } from "react"
import { useContext } from "react"
import { StackerContext } from "components/DYStackers/StackerContext"

function DefaultRoute() {
  console.error("Invalid route specified!") //TODO: probably remove this before release :)
  return <div>Exact routes are required.</div>
}

export function AppRoute() {
  const dispatch = useDispatch()
  const location = useLocation()
  const stackerContext = useContext(StackerContext)
  const stacker = stackerContext.getInstance()

  useEffect(() => {
    dispatch(enableSPA(true))
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual"
    }
    dispatch(getCSRFToken())
  }, [dispatch])

  useLayoutEffect(() => {
    //setPrevPath(location.path)
    // const pos = history.[location.path];
    // if (pos) {
    //   setScroll(0, getValue(pos, "scrollTop", 0));
    // } else {
    //   setScroll();
    // }
    setScroll()
  }, [location])

  return (
    // <ErrorBoundary>
    <Routes>
      {stacker.amuletRoute && (
        <Route
          path={stacker.amuletRoute}
          element={
            <PageWrapper bodyTheme="StackerPageBody" disableDefaultTheme={true}>
              <AmuletStackerPage />
            </PageWrapper>
          }
        />
      )}

      {stacker.braceletRoute && (
        <Route
          path={stacker.braceletRoute}
          element={
            <PageWrapper bodyTheme="StackerPageBody" disableDefaultTheme={true}>
              <BraceletStackerPage />
            </PageWrapper>
          }
        />
      )}
      <Route path="/" element={<DefaultRoute />} />
    </Routes>
    // </ErrorBoundary>
  )
}

export default AppRoute
